/* jshint esversion: 6, -W097 */
/* globals require */
'use strict';

/**
 * Creates the product retailers ratings section
 * Usage example:
 * <retailers-ratings
 * data-ratings="ratings">
 * </retailers-ratings>
 * Ratings object example :
 * var ratings = [{
 * "reviewer_name": "Amazon",
 * "number_of_reviews": "1",
 * "rating_percentage": "2.0",
 * "review_source_link": "http://www.amazon.co.uk/gp/product/B00FNJAZBC/ref=as_li_qf_sp_asin_il_tl?camp=1789&creativeASIN=B00FNJAZBC&creative=9325&tag=eonenergy-21&ie=UTF8&linkCode=as2",
 * "reviewer_logo_url": "//s3.enervee.com/media/offerlogos/amazon_uk_logo.png"
 * },
 * {
 * "reviewer_name": "AO",
 * "number_of_reviews": "7",
 * "rating_percentage": "4.9",
 * "review_source_link": null,
 * "reviewer_logo_url": "//s3.enervee.com/media/offerlogos/ao400.png"
 * }]
 *
 */
/**
 * @module enervee_utils.product_sections
 */
function ratingsDirective() {
    return {
        restrict: 'E',
        scope: {
            title: '@',
            isExpert: '@',
            ratings: '=',
            productDetailData: '='
        },
        controller: ratingsController,
        template: require('./ratingsView.html')
    };
}

ratingsController.$inject = [
    '$scope',
    '$window',
    'AccountAuthService',
    'AnalyticsService',
    'CmsContentService',
    'ProductService',
];
function ratingsController (
    $scope,
    $window,
    AccountAuthService,
    AnalyticsService,
    CmsContentService,
    ProductService
) {
    $scope.ratingLinkClicked = function(rating, index) {
        $scope.trackEvent('Offer Clicked', rating, index);
        window.open(rating.review_source_link, '_blank');
    };

    /**
     * Populates CMS marketplace contents in the directive
     */
    CmsContentService.getMarketPlaceText('details_page:ratings_reviews').then(function(text) {
        $scope.reviewsText = text;
    });
    CmsContentService.getMarketPlaceText('details_page:ratings_read_reviews').then(function(text) {
        $scope.readReviewsText = text;
    });

    /**
     * Popovers
     */
    $scope.ratingsPopoverIsEnabled = true;
    $scope.ratingsPopoverIsOpen = false;

    // Ratings currently share the same disclaimer as offers, so use the offer popover.
    $scope.ratingsPopover = {
        templateUrl: '/app/shared/popovers/ratingsPopover.html'
    };
    // cloudinary image loading support
    $scope.$watch('ratings', function(newRatings) {
        if (newRatings && newRatings.length > 0) {
            newRatings.forEach(function (rating, count) {
                if (!rating.imageId) {
                    rating.imageId = "Rating" + count;
                }
            });
        }
    });

    $scope.getRatingAriaText = function (ratingPercentage) {
        return 'Rated ' + ratingPercentage + 'out of 5 stars';
    };

    $scope.trackRatingViewed = function (rating, index) {
        $scope.trackEvent('Offer Viewed', rating, index);
    };

    $scope.trackEvent = function (eventName, rating, index) {
        var offerDetails = ProductService.getOfferTrackingDetails(rating);
        offerDetails.review = true;
        offerDetails.position = index + 1;
        AnalyticsService.reportEvent(eventName, offerDetails, $scope.productDetailData);
    };
}

module.exports = ratingsDirective;
